import api from '@/api'

const state = {
  armada: [],
  armadaDetail: {},
  armadaHistory: [],
  partnerArmada: [],
  partnerArmadaDetail: {},
  partnerVehicle: []
}
const actions = {
  getArmada({ commit }, { partnerId, params }) {
    return new Promise((resolve, reject) => {
      api.armada.armadaList(partnerId, params).then(
        response => {
          commit('setArmada', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getArmadaDetail({ commit }, { partnerId, vehicleId }) {
    return new Promise((resolve, reject) => {
      api.armada.armadaDetail(partnerId, vehicleId).then(
        response => {
          commit('setArmadaDetail', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  deleteArmada({ _ }, { partnerId, vehicleId }) {
    return new Promise((resolve, reject) => {
      api.armada.deleteArmada(partnerId, vehicleId).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getArmadaHistory({ commit }, { partnerId, vehicleId, params }) {
    return new Promise((resolve, reject) => {
      api.armada.armadaHistory(partnerId, vehicleId, params).then(
        response => {
          commit('setArmadaHistory', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  addNewArmada({ _ }, { partnerId, payloads }) {
    return new Promise((resolve, reject) => {
      api.armada.addNewArmada(partnerId, payloads).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getPartnerArmada({ commit }, { partnerId, params }) {
    return new Promise((resolve, reject) => {
      api.armada.partnerArmada(partnerId, params).then(
        response => {
          commit('setPartnerArmada', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getPartnerArmadaDetail({ commit }, { partnerId, vehiclePartnerId }) {
    return new Promise((resolve, reject) => {
      api.armada.partnerArmadaDetail(partnerId, vehiclePartnerId).then(
        response => {
          commit('setPartnerArmadaDetail', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getPartnerVehicle({ commit }, { partnerId, vehiclePartnerId, params }) {
    return new Promise((resolve, reject) => {
      api.armada.partnerVehicle(partnerId, vehiclePartnerId, params).then(
        response => {
          commit('setPartnerVehicle', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  deletePartner({ commit }, { partnerId, vehiclePartnerId }) {
    return new Promise((resolve, reject) => {
      api.armada.deletePartner(partnerId, vehiclePartnerId).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  createPartnerArmada({ _ }, { partnerId, payloads }) {
    return new Promise((resolve, reject) => {
      api.armada.createPartnerArmada(partnerId, payloads).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  }
}
const mutations = {
  setArmada(state, value) {
    state.armada = value
  },
  setArmadaDetail(state, value) {
    state.armadaDetail = value
  },
  setArmadaHistory(state, value) {
    state.armadaHistory = value
  },
  setPartnerArmada(state, value) {
    state.partnerArmada = value
  },
  setPartnerArmadaDetail(state, value) {
    state.partnerArmadaDetail = value
  },
  setPartnerVehicle(state, value) {
    state.partnerVehicle = value
  }
}
const getters = {
  armada: state => state.armada,
  armadaDetail: state => state.armadaDetail,
  armadaHistory: state => state.armadaHistory,
  partnerArmada: state => state.partnerArmada,
  partnerArmadaDetail: state => state.partnerArmadaDetail,
  partnerVehicle: state => state.partnerVehicle
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
